<template>
    <section id="dashboard-ecommerce">
      <b-col
        md="12"
        lg="12"
      >
        <b-card
          no-body
        >
          <div class="card-header border-bottom">
            <h4 class="card-title">
              Audit Log
            </h4>
          </div>    
  
          <div class="card-datatable table-responsive-l">
            <table class="datatables-ajax table g w-100 ">
              <thead>
                <tr>
                  <th>User</th>
                  <th>Type</th>
                  <th>Action</th>
                  <th>IP Address</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tfoot>
                <tr>
                  <th>User</th>
                  <th>Type</th>
                  <th>Action</th>
                  <th>IP Address</th>
                  <th>Date</th>
                </tr>
              </tfoot>
              <tbody>
                <tr
                  v-for="(item, index) in items"
                  :key="index"
                >
                  <td>{{ index + 1  }}.
                   <span v-if="item.merchant">{{ item.merchant.name }}</span> 
                   <span v-else-if="item.user">{{ item.user.name }}</span> 
                  </td>
                  <td>
                   <span v-if="item.merchant">Merchant</span> 
                   <span v-else-if="item.user">Admin</span> 
                  </td>
                  <td>{{ item.action }}</td>
                  <td>
                    {{ item.ip_address }}
                  </td>
                  <td>{{ formatDate(item.created_at) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
            <div class="mx-2 mb-2">
                <nav aria-label="Page navigation">
                    <ul class="pagination">
                    <li :class="link.active ? 'page-item active' : 'page-item'" v-for="link in links" :key="link.id">
                        <a class="page-link" href="javascript:;" @click="paginate(link.url)" v-html="link.label"></a>
                    </li>
                    </ul>
                </nav>        
            </div>  
        </b-card>
      </b-col>
    </section>
  </template>
  
  <script>
  import {
    BCard, BRow, BCol, BFormInput, BTable, BLink, BForm, BFormGroup,
    BBadge, BPagination, BMedia, BAvatar, VBModal, BButton, BSpinner,
  } from 'bootstrap-vue';
  import Ripple from 'vue-ripple-directive'
  import BCardCode from '@core/components/b-card-code'
  import vSelect from 'vue-select'  
  
  export default {
    components: {
      BCardCode,
      BSpinner,
      BCard,
      BFormGroup,
      BForm,
      BButton,
      BRow,
      BCol,
      BFormInput,
      BTable,
      BLink,
      BBadge,
      BPagination,
      BMedia,
      BAvatar,
      vSelect,
    },
    directives: {
      'b-modal': VBModal,
      Ripple,
    },
    data() {
      return {
        showForm: false,
        loading: false,
        action: '',
        items: [],
        meta: {},
        links: {},
        url: '',
      };
    },
    created() {
        this.url = this.$url+'/logs'
      this.getAuditLogs();
    },
    methods: {
      getAuditLogs() {
        this.$http.get(this.url)
          .then((response) => {
            if (response.data.status) {
              const items = response.data.data.data;
              this.items = items;
              this.links = response.data.data.links  
            }
          });
      },
      paginate(url) {
        this.url = url
        this.getAuditLogs()
      },
        formatDate(dateStr) {
            const options = { 
                year: 'numeric', 
                month: 'long', 
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true 
            };
            return new Date(dateStr).toLocaleString('en-US', options);
        }
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .per-page-selector {
    width: 90px;
  }
  
  .invoice-filter-select {
    min-width: 190px;
  
    ::v-deep .vs__selected-options {
      flex-wrap: nowrap;
    }
  
    ::v-deep .vs__selected {
      width: 100px;
    }
  }
  </style>
  
  <style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  </style>
  